module.exports = __webpack_public_path__ + "img/chip.2c37b1d3.png";